import React, { useState } from "react"
import webify from "../util/webify"

interface SwitchInputProps {
  checked: boolean
  name: string
  labelOn: string
  labelOff: string
  labelClass: string
  "data-role"?: string
  permissionToEdit: string
  onChange?: () => any
}

const SwitchInput = (props: SwitchInputProps) => {
  const { labelOn, labelOff, name, onChange, labelClass, permissionToEdit } = props
  const [checked, setChecked] = useState(props.checked)
  let switchClasses
  let circlePosition

  if (checked) {
    switchClasses = "block w-16 h-8 bg-green-500 rounded-full shadow--inner"
    circlePosition = "translate-x-8"
  } else {
    switchClasses = "block w-16 h-8 bg-gray-300 rounded-full shadow--inner"
    circlePosition = "translate-x-0"
  }
  return (
    <>
      <label
        htmlFor={name}
        className={`w-full flex items-center cursor-pointer ${labelClass}`}
        data-role={props["data-role"]}
        onClick={() => {
          if (permissionToEdit == "true") {
            setChecked(!checked)
            onChange && onChange()
          }
        }}>
        <span className="relative">
          <span className={switchClasses}></span>
          <span
            className={`absolute block w-6 h-6 mt-1 ml-1 ${circlePosition} bg-white rounded-full shadow--lg inset-y-0 inline-start-0 focus-within:ring transform duration-300 ease-in-out`}>
            <input type="hidden" name={name} value={checked ? "true" : "false"} className="absolute opacity-0 w-0 h-0" />
          </span>
        </span>

        <div className={labelClass + " ml-3"}>{checked ? labelOn : labelOff}</div>
      </label>
    </>
  )
}

export default SwitchInput
webify("switch-input", SwitchInput)
